/**
 * Monta o alerta de "provisionamento iniciado" a partir da resposta de
 * `POST /end-customer/instances`.
 *
 * Existe como função pura porque o que ela decide é conteúdo, não interação: se
 * a resposta traz `warnings` (ex.: VPC sem Cloud Gateway — a VM sobe sem DHCP e
 * sem internet, issue #727), o cliente precisa lê-los, e o alerta deixa de ser
 * um "sucesso" liso. O tipo do parâmetro é o corpo da resposta — `apiClient.post`
 * já devolve `response.data`, sem envelope.
 */

export type RespostaDeCriacaoDeVm = {
  warnings?: string[]
}

/** A navegação pós-criação casa por este título — por isso ele é constante,
 *  e não literal repetido em dois arquivos. */
export const TITULO_PROVISIONAMENTO = 'Provisionamento Iniciado'

export type AlertaDeCriacao = {
  title: string
  message: string
  variant: 'success' | 'warning'
}

export function montarAlertaDeCriacao(
  resposta: RespostaDeCriacaoDeVm | undefined,
  quantidade: number,
): AlertaDeCriacao {
  const avisos = resposta?.warnings ?? []
  const base =
    quantidade > 1
      ? `Suas ${quantidade} VMs estão sendo provisionadas. Acompanhe o status na página de instâncias.`
      : 'Sua VM está sendo provisionada. Acompanhe o status na página de instâncias.'

  return {
    title: TITULO_PROVISIONAMENTO,
    // `\n` funciona: o AlertModal renderiza a mensagem com `whitespace-pre-line`.
    message: avisos.length > 0 ? `${base}\n\n${avisos.join('\n')}` : base,
    variant: avisos.length > 0 ? 'warning' : 'success',
  }
}
